import React from 'react'
import BigBox from '../../components/ad_types/BigBox'
import Teammates from './shared/teammates/Teammates'
import TSCAdComponent from '../../components/ad_types/TSCAdComponent'
import PlayerSalary from './shared/player_salary/PlayerSalary'

const Sidebar = ({ sport, league, teamId, teammates, salary }) => {
    return (
        <div>
            <BigBox bg={false} view="all" visible={true} refresh={false} />
            {league === 'nhl' && <PlayerSalary salary={salary} />}
            <Teammates teammates={teammates} sport={sport} league={league} teamId={teamId} />
            <TSCAdComponent league={league} />
        </div>
    )
}

export default Sidebar
